import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { PineappleIcon } from "@/components/PineappleIcon";
import { BUSINESS_HOURS, TELEGRAM_URL, NAV_LINKS, PHONE_DISPLAY, waLink } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-charcoal text-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <PineappleIcon className="h-9 w-7 text-gold" />
            <span className="leading-none">
              <span className="block font-serif text-xl font-bold">LOBANG</span>
              <span className="block font-cinzel text-[9px] font-semibold uppercase tracking-[0.32em] text-gold-light">
                Home Inspection
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/60">
            Independent defect inspections for new BTO flats, condos and landed homes across Singapore. Precision in
            every check, prosperity in every home.
          </p>
          <p className="mt-4 font-serif text-sm italic text-gold-light/80">旺来 — prosperity arrives.</p>
        </div>
        <div>
          <p className="font-cinzel text-xs font-semibold uppercase tracking-[0.28em] text-gold">Explore</p>
          <nav className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3" aria-label="Footer">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="text-sm text-ivory/70 transition-colors hover:text-gold-light"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div>
          <p className="font-cinzel text-xs font-semibold uppercase tracking-[0.28em] text-gold">Book an Inspection</p>
          <p className="mt-5 text-sm text-ivory/70">Fastest response on WhatsApp</p>
          <p className="mt-2 text-sm text-ivory/80">{BUSINESS_HOURS}</p>
          <a href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} className="mt-1 block font-serif text-2xl font-semibold text-ivory" data-testid="footer-phone">
            {PHONE_DISPLAY}
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-cta"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-wa px-6 py-3 text-sm font-bold text-white shadow-wa transition-transform duration-300 hover:scale-[1.03]"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp Us Now
          </a>
          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="mt-4 block text-sm font-semibold text-gold-light underline underline-offset-4">Telegram: @lobanghomeinspection</a>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-ivory/10 pt-8 sm:flex-row">
        <p className="text-xs text-ivory/40">© 2026 Lobang Home Inspection. All rights reserved.</p>
        <p className="text-xs text-ivory/40">BTO · Condo · Landed — Islandwide Singapore</p>
      </div>
    </div>
  </footer>
);
